<div (appClickOutside)="collapse = true">
	<input type="text" [value]="showedValue" (focusout)="onFocusOut($event)" (input)="validateInput($event)"
		[attr.disabled]="disabled">
	<app-icon *ngIf="disabled === null" (click)="collapse = !collapse">today</app-icon>

	<app-select-date *ngIf="!collapse" [value]="selectedValue" (appClose)="selectedDate($event)">
	</app-select-date>
</div>
